import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Music } from "lucide-react";

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <header className="bg-[#FAF9F6]/90 backdrop-blur-md border-b border-[#6B8576]/10 sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-9 h-9 bg-[#6B8576] rounded-2xl flex items-center justify-center">
              <Music className="w-4 h-4 text-white" strokeWidth={1.5} />
            </div>
            <span className="font-semibold text-[#2A3A31]" style={{ fontFamily: 'Outfit' }}>Audio Sur Mesure</span>
          </Link>
          <Link to="/" className="text-sm text-[#6B8576] font-medium hover:underline flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Retour
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-testid="politique-confidentialite-page">
        <h1 className="text-3xl font-semibold text-[#2A3A31] mb-8" style={{ fontFamily: 'Outfit' }}>Politique de confidentialité</h1>
        
        <div className="prose prose-sm max-w-none space-y-8 text-[#2C3531]" style={{ fontFamily: 'Manrope' }}>
          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Données collectées</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Lors de votre inscription et utilisation de l'application, nous collectons :
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-[#5C6A61]">
              <li>Votre prénom et adresse email (inscription)</li>
              <li>Vos réponses aux exercices pratiques</li>
              <li>Vos entrées dans le carnet de crise</li>
              <li>Les messages envoyés via le formulaire de contact</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Finalité du traitement</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Vos données sont utilisées uniquement pour :
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-[#5C6A61]">
              <li>Vous permettre d'accéder à votre espace personnel et de sauvegarder votre progression</li>
              <li>Vous envoyer des notifications liées à l'application (nouveaux audios, conseils)</li>
              <li>Répondre à vos messages de contact</li>
            </ul>
            <p className="leading-relaxed text-[#5C6A61] mt-2">
              Vos données ne sont jamais vendues, cédées ou partagées avec des tiers à des fins commerciales.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Durée de conservation</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Vos données sont conservées tant que votre compte est actif. En cas de suppression de votre compte, toutes vos données personnelles seront effacées dans un délai de 30 jours.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Vos droits (RGPD)</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 text-[#5C6A61]">
              <li><strong>Droit d'accès</strong> : obtenir une copie de vos données personnelles</li>
              <li><strong>Droit de rectification</strong> : corriger des données inexactes</li>
              <li><strong>Droit à l'effacement</strong> : demander la suppression de vos données</li>
              <li><strong>Droit à la portabilité</strong> : recevoir vos données dans un format structuré</li>
              <li><strong>Droit d'opposition</strong> : vous opposer au traitement de vos données</li>
            </ul>
            <p className="leading-relaxed text-[#5C6A61] mt-2">
              Pour exercer ces droits, contactez-nous à : <a href="mailto:brylynda@gmail.com" className="text-[#6B8576] hover:underline">brylynda@gmail.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Cookies</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Ce site utilise uniquement des cookies strictement nécessaires au fonctionnement de l'application (authentification, session utilisateur). Aucun cookie publicitaire ou de traçage n'est utilisé.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Sécurité</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Nous mettons en place des mesures de sécurité techniques et organisationnelles pour protéger vos données : chiffrement des mots de passe, connexion HTTPS, accès restreint aux données.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#2A3A31] mb-3" style={{ fontFamily: 'Outfit' }}>Contact</h2>
            <p className="leading-relaxed text-[#5C6A61]">
              Pour toute question relative à vos données personnelles :<br />
              Lynda Bry-Bonnard<br />
              Email : <a href="mailto:brylynda@gmail.com" className="text-[#6B8576] hover:underline">brylynda@gmail.com</a><br />
              Téléphone : 06 64 26 00 50
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
